import DropzoneFiles from "./DropzoneFiles";

export default DropzoneFiles;
